import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { NgClass, DatePipe } from '@angular/common';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ResizePipe } from '@teamfoster/sdk/image';

@Component({
  selector: 'app-href-card',
  templateUrl: './href-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IconComponent, DatePipe, ResizePipe],
})
export class HrefCardComponent {
  readonly imageAnchor = input<
    | 'topleft'
    | 'topcenter'
    | 'topright'
    | 'middleleft'
    | 'middlecenter'
    | 'middleright'
    | 'bottomleft'
    | 'bottomcenter'
    | 'bottomright'
    | undefined
  >();
  readonly imageUrl = input<string>();
  readonly videoUrl = input<string>();
  readonly title = input<string>();
  readonly subTitle = input<string>();
  readonly text = input<string>();
  readonly date = input<Date>();
  readonly author = input<string>();
  readonly href = input<string>();
  readonly showTime = input<boolean>();
  readonly showDate = input<boolean>();
  readonly size = input<string>();
  readonly target = input<string>();
}
